import * as yup from "yup";

export const customerNotesSchema = yup.object().shape({
  note: yup.string().label("Customer Note").required().default(""),
});
